import styled from "styled-components";
import {ConfettiZIndex} from "../../wheel-of-jackpotbet/confetti/confetti.component.interface";

export const Magic8BallOverlayDefaultBox = styled.div<{isShown: boolean}>`
    display: ${props => props.isShown ? "flex" : "none"};
    align-items: center;
    justify-content: center;
    user-select: none;
    z-index: ${ConfettiZIndex.AboveEverything};
    overflow: hidden;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #00000077;
    backdrop-filter: blur(4px);
`;